

export const veoHero = {
    title: 'AI 视频生成器',
    desc:
      '体验电影级的 AI 视频创作。支持关键帧模式、片段延长（超过 8 秒）、原生音频同步，并提供真实运动生成、多图参考控制与 1080P 画质。从文字或图片到专业视频，轻松开启创作。'
  };
